<template>
  <img class="off" src="/public/icons/single-off.svg" alt="" />
  <img class="on" src="/public/icons/single-on.svg" alt="" />
</template>

<script>
export default {
  name: 'IconSingle',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
